import { Dialog, DialogContent, DialogProps } from "@mui/material";
import { Box } from "@mui/system";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import AssignmentCreateUpdate, { AssignmentCreateUpdateProps } from "./AssignmentCreateUpdate";

export interface OwnProps {
  createUpdateProps: AssignmentCreateUpdateProps;
}

type Props = OwnProps & DialogProps;

export default function AssignmentCreateUpdateModal({ createUpdateProps, ...dialogProps }: Props) {
  const isCreate = !createUpdateProps.assignmentId;

  return (
    <Dialog fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        {isCreate ? "Create new" : "Edit"} assignment
      </AppModalTitle>
      <DialogContent>
        <Box sx={{ py: 1 }}>
          <AssignmentCreateUpdate {...createUpdateProps} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
